import { ApolloClient } from '@apollo/client';
import { BaseDataProvider, DataProviderParams, DataProviderResult } from '../base/BaseDataProvider';
import { GET_ALL_CHAT_MESSAGES } from '../queries/chat.queries';

export class ChatDataProvider extends BaseDataProvider {
  async getList(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    this.logInfo(resource, 'getList', params);
    
    const { page, perPage } = params.pagination || { page: 1, perPage: 25 };
    
    try {
      const result = await this.client.query({
        query: GET_ALL_CHAT_MESSAGES,
        variables: { limit: perPage * 3 }, // Загружаем больше сообщений для пагинации
        fetchPolicy: 'network-only',
      });

      const data = result.data.getAllChatMessages || [];
      this.logSuccess(resource, 'getList', { dataLength: data.length });

      return {
        data,
        total: Math.max(data.length, perPage * page),
      };
    } catch (error: any) {
      this.logError(resource, 'getList', error, params);
      return { data: [], total: 0 };
    }
  }

  async getOne(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    this.logInfo(resource, 'getOne', params);

    try {
      const result = await this.client.query({
        query: GET_ALL_CHAT_MESSAGES,
        variables: { limit: 1000 }, // Получаем много сообщений, чтобы найти нужное
        fetchPolicy: 'network-only',
      });

      const messages = result.data.getAllChatMessages || [];
      const message = messages.find((msg: any) => msg.id === params.id);
      
      if (!message) {
        throw new Error(`Message with id ${params.id} not found`);
      }

      this.logSuccess(resource, 'getOne', message);
      return { data: message };
    } catch (error: any) {
      this.logError(resource, 'getOne', error, params);
      throw error;
    }
  }

  async create(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    console.log('Create not implemented for chat messages:', params);
    return { data: { id: Date.now(), ...params.data } };
  }

  async update(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    console.log('Update not implemented for chat messages:', params);
    return { data: { id: params.id, ...params.data } };
  }

  async delete(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    console.log('Delete not implemented for chat messages:', params);
    return { data: { id: params.id } };
  }
}
